const WORDPRESS_UNBOUNDED_TEXT_FIELDS = new Set([
  'alt',
  'imagealt',
  'imagesearchquery',
  'leadparagraph',
  'metadescription',
  'slug',
  'title',
])

function normalize(value) {
  return String(value || '').replace(/[^a-z0-9]/gi, '').toLowerCase()
}

function isUnboundedWordpressTextField(field, streamType) {
  return String(streamType || '').trim().toUpperCase() === 'WORDPRESS'
    && WORDPRESS_UNBOUNDED_TEXT_FIELDS.has(normalize(field?.name))
}

export function withoutWordpressTextLengthLimits(form, streamType) {
  if (!form || !Array.isArray(form.sections) || String(streamType || '').trim().toUpperCase() !== 'WORDPRESS') return form
  return {
    ...form,
    sections: (form.sections ?? []).map(section => ({
      ...section,
      fields: (section.fields ?? []).map(field => (
        isUnboundedWordpressTextField(field, streamType)
          ? { ...field, minLength: null, maxLength: null }
          : field
      )),
    })),
  }
}
